import { combineReducers } from "redux";
import auth from "./authReducer";
import toast from "./toastReducer";


export default combineReducers({
    auth,
    toast,
});
